import { logAppError } from 'Helpers/logger'
import type { CallbackInterface } from 'recoil'

import type { PageStateType } from 'Types/state'

import { errorUpdater, loaderUpdater, pageState } from 'State/page'

import { notifySetPendingSendConfirmationSuccess } from 'Pages/RecipientsList/recoil/services/notifications'
import { updateRecipientSubscriptionStatus } from 'Pages/RecipientsList/recoil/services/recipient'
import { modalPendingState } from 'Pages/RecipientsList/recoil/state/modalPending'

import { reloadRecipientCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'

export const modalPendingCancelCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalPendingState)
  }

export const modalPendingChangeMessageCallback =
  ({ set }: CallbackInterface) =>
  async (idConfirmationMessage: number) => {
    set(modalPendingState, (prev) => ({
      ...prev,
      idConfirmationMessage,
      idConfirmationMessageIsDirty: true,
    }))
  }

export const modalPendingConfirmCallback =
  ({ set, snapshot, reset, ...cbi }: CallbackInterface) =>
  async (sendConfirmationMessage: boolean) => {
    set<PageStateType>(pageState, loaderUpdater(true))

    const { idRecipient, idConfirmationMessage, contact } =
      await snapshot.getPromise(modalPendingState)

    try {
      //  TODO set pending with optional conf message

      const optionalParams = sendConfirmationMessage
        ? {
            idConfirmationMessage,
          }
        : {}

      await updateRecipientSubscriptionStatus(
        idRecipient,
        'EMAIL',
        'PENDING',
        optionalParams,
      )

      await reloadRecipientCallback({ set, snapshot, reset, ...cbi })(
        idRecipient,
      )

      //  notify success

      notifySetPendingSendConfirmationSuccess(sendConfirmationMessage, contact)
    } catch (error) {
      logAppError({
        Component: 'RecipientsList',
        Method: 'modalPendingConfirmCallback',
        appError: error,
      })

      set<PageStateType>(pageState, errorUpdater)
    }

    reset(modalPendingState)

    set<PageStateType>(pageState, loaderUpdater(false))
  }
